// extracted by mini-css-extract-plugin
module.exports = {"container":"VirtualMeetingIcon_container__3cmvH","img":"VirtualMeetingIcon_img__1Vx9-","text":"VirtualMeetingIcon_text__38PtI"};